import { createAsyncThunk } from "@reduxjs/toolkit";
import ShopApi from "api/ShopApi";

export const fetchShops = createAsyncThunk(
  "fetchShops",
  ({ companyId }: { companyId: number }) => ShopApi.fetchShops(companyId)
);
